import { ICustomer } from "@/types/ICustomer"

export interface IFinanceReturnFunds {
  id: number
  date: string
  clientName: string
  sum: number
  status: ReturnStatus
  statusText: string
  customer: ICustomer
  customerId: number
  createdOn: Date,
  requisites: ClientRequisites
}

export interface IFinanceReturnFundsCreate {
  date: string
  sum: number
  customerId: number

  inn: string
  kpp: string
  ogrn: string
  bik: string
  kbk: string
  oktmo: string
  recieverName: string
  bankName: string
  /** расчетный счет */
  currentAccount: string
  /** корреспонд. счет */
  correspondentAccount: string
}

export interface ClientRequisites {
  inn: string
  kpp: string
  ogrn: string
  bik: string
  kbk: string
  oktmo: string
  recieverName: string
  bankName: string
  /** расчетный счет */
  currentAccount: string
  /** корреспонд. счет */
  correspondentAccount: string
}

export interface IReturnChangeStatus {
  returnId: number
  status: ReturnStatus
}

export enum ReturnStatus {
  InProgress,
  Done,
  Cancelled
}

export const FINANCE_RETURN_FUNDS_KEY = "FINANCE_RETURN_FUNDS_KEY"